import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FullScreen from '@/components/customUI/Loaders/FullScreen';
import AuthRoutes from './routes/Auth';
import getProtectedRoutes from './ProtectedRoutes';

const NotFound = lazy(() => import('@/pages/not-found'));

function Navigation() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
      <Suspense fallback={<FullScreen hasSpinner={true} />}>
        <Routes>
          {AuthRoutes}
          {getProtectedRoutes()}

          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default Navigation;
